import { render, staticRenderFns } from "./external-upload-layout.vue?vue&type=template&id=9d4523f0&scoped=true&"
import script from "./external-upload-layout.vue?vue&type=script&lang=js&"
export * from "./external-upload-layout.vue?vue&type=script&lang=js&"
import style0 from "./external-upload-layout.vue?vue&type=style&index=0&id=9d4523f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4523f0",
  null
  
)

export default component.exports